var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAdultFillLabel = function SvgIconAdultFillLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.565 1.037a.884.884 0 0 0-1.13 0A22.5 22.5 0 0 1 4.493 4.13l-1.945.89a.808.808 0 0 0-.463.798l.538 7.121c.097 1.28.8 2.429 1.879 3.072l5.118 3.05a.74.74 0 0 0 .76 0l5.118-3.05a3.912 3.912 0 0 0 1.878-3.072l.538-7.12a.808.808 0 0 0-.462-.799l-1.946-.89a22.502 22.502 0 0 1-4.941-3.093Zm1.518 7.713a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0Zm2.594 5.021c.252.284.24.718-.058.952-.09.07-.182.135-.279.195l-4.04 2.496a.566.566 0 0 1-.6 0l-4.04-2.496a2.987 2.987 0 0 1-.28-.195c-.297-.234-.31-.668-.058-.952A6.235 6.235 0 0 1 10 11.667c1.86 0 3.532.813 4.677 2.104Z",
    fill: "#FF970C"
  })));
};
export default SvgIconAdultFillLabel;